{
    "ConfigureAgents_Add_Title": "Nieuwe agent toevoegen",
    "ConfigureAgents_Modify_Title": "Agent wijzigen",
    "ConfigureAgents_PromptMessage": "Weet je zeker dat je dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren bij het sluiten.",
    "ConfigureAgents_PromptConfirm": "Ja",
    "ConfigureAgents_PromptCancel": "Annuleren",
    "ConfigureAgents_Tabs_Details": "Agent Details",
    "ConfigureAgents_Tabs_Advanced": "Geavanceerd",
    "ConfigureAgents_Tabs_Omnichannel": "Omnichannel",
    "ConfigureAgents_Footer_Help": "Helpen?",
    "ConfigureAgents_Footer_Submit": "Sla",
    "ConfigureAgents_Footer_Cancel": "Annuleren",
    "NAME": "ConfigureAgents",
    "ConfigureAgents_Tabs_LinkedEntities": "Gekoppelde entiteiten"
}